/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module basic-styles/cite
 */

import { Plugin } from 'ckeditor5/src/core';
import CiteEditing from './cite/citeediting';
import CiteUI from './cite/citeui';

/**
 * The cite feature.
 *
 * For a detailed overview check the {@glink features/basic-styles Basic styles feature documentation}
 * and the {@glink api/basic-styles package page}.
 *
 * This is a "glue" plugin which loads the {@link module:basic-styles/cite/citeediting~CiteEditing} and
 * {@link module:basic-styles/cite/citeui~citeUI} plugins.
 *
 * @extends module:core/plugin~Plugin
 */
export default class Cite extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [ CiteEditing, CiteUI ];
	}

	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'Cite';
	}
}
